import React from "react";
import PropTypes from "prop-types";
import { Link, withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableFooter from "@material-ui/core/TableFooter";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LastPageIcon from "@material-ui/icons/LastPage";
import TableHead from "@material-ui/core/TableHead";
import BorderColorIcon from "@material-ui/icons/BorderColor";
import GetAppRoundedIcon from "@material-ui/icons/GetAppRounded";
import EditRoundedIcon from "@material-ui/icons/EditRounded";
import DeleteForeverRoundedIcon from "@material-ui/icons/DeleteForeverRounded";
import Switch from "@material-ui/core/Switch";
import API from "../../api/api";
import Typography from "@material-ui/core/Typography";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

import CircularProgress from "@material-ui/core/CircularProgress";
import LinearProgress from "@material-ui/core/LinearProgress";
const userId = localStorage.getItem("userId");
let counter = 0;
function createData(id, updated_at, status, user_id) {
  counter += 1;
  return { idNum: counter, id, updated_at, status, user_id };
}
const rows = [
  {
    id: "id",
    numeric: false,
    disablePadding: false,
    label: "Certificate id",
  },
  {
    id: "updated_at",
    numeric: false,
    disablePadding: false,
    label: "Updated at",
  },
  {
    id: "status",
    numeric: false,
    disablePadding: false,
    label: "Status",
  },
  {
    id: "download",
    numeric: false,
    disablePadding: false,
    label: "Action",
  },
];
class EnhancedTableHead extends React.Component {
  createSortHandler = (property) => (event) => {
    this.props.onRequestSort(event, property);
  };

  render() {
    const { order, orderBy } = this.props;

    return (
      <TableHead>
        <TableRow>
          {rows.map((row) => {
            return (
              <TableCell
                key={row.id}
                numeric={row.numeric}
                padding={row.disablePadding ? "none" : "default"}
                sortDirection={orderBy === row.id ? order : false}
                style={{ color: "#606060", paddingRight: "30px" }}
              >
                {row.label}
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
};

const actionsStyles = (theme) => ({
  root: {
    flexShrink: 0,
    color: theme.palette.text.secondary,
    marginLeft: theme.spacing.unit * 2.5,
  },
});

class TablePaginationActions extends React.Component {
  handleFirstPageButtonClick = (event) => {
    this.props.onChangePage(event, 0);
  };

  handleBackButtonClick = (event) => {
    this.props.onChangePage(event, this.props.page - 1);
  };

  handleNextButtonClick = (event) => {
    this.props.onChangePage(event, this.props.page + 1);
  };

  handleLastPageButtonClick = (event) => {
    this.props.onChangePage(
      event,
      Math.max(0, Math.ceil(this.props.count / this.props.rowsPerPage) - 1)
    );
  };

  render() {
    const { classes, count, page, rowsPerPage, theme } = this.props;

    return (
      <div className={classes.root}>
        <IconButton
          onClick={this.handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="First Page"
        >
          {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
          onClick={this.handleBackButtonClick}
          disabled={page === 0}
          aria-label="Previous Page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowRight />
          ) : (
            <KeyboardArrowLeft />
          )}
        </IconButton>
        <IconButton
          onClick={this.handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="Next Page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowLeft />
          ) : (
            <KeyboardArrowRight />
          )}
        </IconButton>
        <IconButton
          onClick={this.handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="Last Page"
        >
          {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </div>
    );
  }
}

TablePaginationActions.propTypes = {
  classes: PropTypes.object.isRequired,
  count: PropTypes.number.isRequired,
  onChangePage: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  theme: PropTypes.object.isRequired,
};

const TablePaginationActionsWrapped = withStyles(actionsStyles, {
  withTheme: true,
})(TablePaginationActions);

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
    marginBottom: theme.spacing.unit * 3,
    backgroundColor: "#fafafa",
  },
  table: {
    minWidth: 500,
  },
  tableWrapper: {
    overflowX: "auto",
  },
  title: {
    color: "#029ae3",
    fontSize: 24,
  },
  MuiDialogTitle: {
    root: {
      color: "blue",
    },
  },
  progress: {
    margin: theme.spacing.unit * 3,
  },
});

class FormStatus extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      page: 0,
      rowsPerPage: 10,
      isDownload: false,
      order: "asc",
      orderBy: "updated_at",
      open: false,
      certificateId: "",
      completed: 0,
    };
  }
  componentDidMount() {
    this.timer = setInterval(this.progress, 500);
    API.get(
      `certificate/get-user-certificates?user_id=${this.props.profileData.id}`
    ).then((data) => {
      this.setState({
        data: data.data.map((certificate) =>
          createData(certificate.id, certificate.updated_at, certificate.status)
        ),
      });
    });
  }
  handleClickOpen(id) {
    this.setState({
      open: true,
      certificateId: id,
    });
  }

  handleClose = () => {
    this.setState({ open: false });
  };
  downloadPdf(id) {
    this.setState({
      isDownload: true,
    });
    API.get(
      `certificate/print-certificate?user_id=${this.props.profileData.id}&certificate_id=` +
        id,
      {
        responseType: "blob",
      }
    )
      .then((res) => {
        if (res.status === 200) {
          const downloadUrl = window.URL.createObjectURL(new Blob([res.data]));

          const link = document.createElement("a");

          link.href = downloadUrl;

          link.setAttribute("download", "certificate.pdf"); //any other extension

          document.body.appendChild(link);

          link.click();

          link.remove();
          this.setState({
            isDownload: false,
          });
        } else {
          this.setState({
            isDownload: false,
          });
        }
      })
      .catch((err) => {
        console.log("AXIOS ERROR: ", err);
      });
  }
  editCertificateById = (id, status) => {
    if (status === "draft") {
      API.get(
        `certificate/get-certificate_data?user_id=${this.props.profileData.id}&certificate_id=${id}&blobs=true`
      )
        .then((res) => {
          var draftData = res.data.data.certificate_data;

          if (draftData.status === "draft") {
            sessionStorage.setItem("certificate_id", id);
            sessionStorage.setItem("diagram", draftData.diagram);
            sessionStorage.setItem("diagramdata", draftData.diagram_data);
            sessionStorage.setItem("active_section", draftData.active_section);
            if (draftData.active_section == 9) {
              sessionStorage.setItem("section_status", "completed");
            }
            sessionStorage.setItem("sectionAdata", draftData.section_A);
            sessionStorage.setItem("sectionBdata", draftData.section_B);
            sessionStorage.setItem("sectionCdata", draftData.section_C);
            sessionStorage.setItem("sectionDdata", draftData.section_D);
            sessionStorage.setItem("sectionEdata", draftData.section_E);
            sessionStorage.setItem("sectionFdata", draftData.section_F);
            sessionStorage.setItem("sectionGdata", draftData.section_G);
            sessionStorage.setItem("sectionHdata", draftData.section_H);

            sessionStorage.setItem("attachment", draftData.s3_links);

            var active = 0;
            if (!draftData.section_A) {
              active = 1;
            } else if (!draftData.section_B) {
              active = 2;
            } else if (!draftData.section_C) {
              active = 3;
            } else if (!draftData.section_D) {
              active = 4;
            } else if (!draftData.section_E) {
              active = 5;
            } else if (!draftData.section_F) {
              active = 6;
            } else if (!draftData.section_G) {
              active = 7;
            } else if (!draftData.section_H) {
              active = 8;
            }
            this.props.history.push({
              pathname: `/ElevationForm/${this.props.profileData.id}`,
              search: `?draft_certificate_id=${id}`,
              state: draftData,
            });
          }
        })
        .catch((err) => {
          // this.props.history.push(`/Questionnaire/${this.state.userId}`);
          console.log("AXIOS ERROR: ", err);
        });
    }
  };
  deleteCertificateById = () => {
    var cId = this.state.certificateId;
    API.get(
      `certificate/certificate_delete?user_id=${this.props.profileData.id}&certificate_id=` +
        cId
    )
      .then((res) => {
        this.setState({ open: false });
        window.location.reload();
        // this.forceUpdate()
      })
      .catch((err) => {
        console.log("AXIOS ERROR: ", err);
      });
  };
  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ page: 0, rowsPerPage: event.target.value });
  };
  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = "desc";
    if (this.state.orderBy === property && this.state.order === "desc") {
      order = "asc";
    }
    this.setState({ order, orderBy });
  };

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  progress = () => {
    const { completed } = this.state;
    if (completed === 100) {
      this.setState({ completed: 0 });
    } else {
      const diff = Math.random() * 10;
      this.setState({ completed: Math.min(completed + diff, 100) });
    }
  };
  render() {
    const { classes } = this.props;
    const { data, rowsPerPage, page, order, orderBy } = this.state;
    const emptyRows =
      rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);
    return (
      <Paper className={classes.root}>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title" className={classes.title}>
            Are you sure want to delete this certificate?
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Certificate will be deleted by clicking yes
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="disabled">
              No
            </Button>
            <Button
              onClick={this.deleteCertificateById}
              variant="contained"
              color="primary"
            >
              Yes
            </Button>
          </DialogActions>
        </Dialog>
        <div className={classes.tableWrapper}>
          <Table className={classes.table}>
            <EnhancedTableHead
              order={order}
              orderBy={orderBy}
              onRequestSort={this.handleRequestSort}
            />
            <TableBody>
              {data
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((data) => (
                  <TableRow key={data.id}>
                    <TableCell component="th" scope="row">
                      {data.id}
                    </TableCell>
                    <TableCell align="right">{data.updated_at}</TableCell>
                    <TableCell align="right">{data.status}</TableCell>

                    <TableCell className={classes.fixedTd}>
                      <EditRoundedIcon
                        onClick={() =>
                          this.editCertificateById(data.id, data.status)
                        }
                        className="action margin-r"
                        color={data.status !== "draft" ? "disabled" : "inherit"}
                      />
                      <GetAppRoundedIcon
                        color={
                          data.status !== "completed" ? "disabled" : "inherit"
                        }
                        onClick={() => this.downloadPdf(data.id)}
                        className="action margin-r"
                      />
                      <DeleteForeverRoundedIcon
                        className="action margin-r"
                        variant="outlined"
                        color={data.status !== "draft" ? "disabled" : "inherit"}
                        onClick={() => this.handleClickOpen(data.id)}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              {this.state.isDownload && (
                <TableRow>
                  <TableCell colSpan={6}>
                    <LinearProgress
                      variant="determinate"
                      value={this.state.completed}
                    />
                  </TableCell>
                </TableRow>
              )}
              {emptyRows > 0 && (
                <TableRow style={{ height: 48 * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  // component="div"
                  rowsPerPageOptions={[5, 10, 25]}
                  colSpan={3}
                  count={data.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  // SelectProps={{
                  //   native: true,
                  // }}
                  onChangePage={this.handleChangePage}
                  onChangeRowsPerPage={this.handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActionsWrapped}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </div>
      </Paper>
    );
  }
}

FormStatus.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withRouter(withStyles(styles)(FormStatus));



// WEBPACK FOOTER //
// ./src/pages/Users/FormStatus.js